export default __webpack_public_path__ + "static/media/exclusive-tournament-game-cover.792d70ee.jpg";